var _path, _path2, _polygon, _polygon2, _path3, _polygon3, _path4, _polygon4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeaceJusticeSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303.71,
    height: 525.42,
    viewBox: "0 0 303.71 525.42",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42.49,524.23c0,.66.53,1.19,1.19,1.19h258.84c.66,0,1.19-.53,1.19-1.19s-.53-1.19-1.19-1.19H43.68c-.66,0-1.19.53-1.19,1.19Z",
    fill: "#484565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m178.61.33s-21.91-5.31-35.17,26.77c-11.05,26.74-18.89,41.02-9.92,50.72,3.21,3.47,7.79,5.34,12.51,5.5l50.5,1.66s18.54-48.62,7.27-66.2C192.53,1.19,178.61.33,178.61.33Z",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "189.07 80.94 164.78 88.93 164.78 53.96 186.82 53.96 189.07 80.94",
    fill: "#f6a6a9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.43 504.69 147.67 504.69 134.48 383.11 169.65 383.11 170.43 504.69",
    fill: "#f6a6a9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m125.51,524.23c-2.39,0-4.52-.06-6.13-.21-6.05-.55-11.81-5.01-14.71-7.62-1.3-1.17-1.72-3.04-1.04-4.65h0c.49-1.16,1.46-2.02,2.66-2.36l15.97-4.56,25.86-17.45.29.52c.11.19,2.65,4.77,3.5,7.86.32,1.18.24,2.16-.25,2.91-.34.53-.81.83-1.2,1,.47.49,1.94,1.48,6.45,2.2,6.6,1.05,7.98-5.79,8.04-6.08l.04-.23.2-.13c3.14-2.02,5.07-2.94,5.74-2.75.42.12,1.11.33,2.98,18.95.19.58,1.5,4.87.61,8.96-.97,4.46-20.44,2.92-24.34,2.57-.11.01-14.69,1.05-24.68,1.05v.02h.01Z",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.83 504.69 199.08 504.69 185.88 383.11 221.05 383.11 221.83 504.69",
    fill: "#f6a6a9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m176.92,524.23c-2.39,0-4.52-.06-6.13-.21-6.05-.55-11.81-5.01-14.71-7.62-1.3-1.17-1.72-3.04-1.04-4.65h0c.49-1.16,1.46-2.02,2.66-2.36l15.97-4.56,25.86-17.45.29.52c.11.19,2.65,4.77,3.5,7.86.32,1.18.24,2.16-.25,2.91-.34.53-.81.83-1.2,1,.47.49,1.94,1.48,6.45,2.2,6.6,1.05,7.98-5.79,8.04-6.08l.04-.23.2-.13c3.14-2.02,5.07-2.94,5.74-2.75.42.12,1.11.33,2.98,18.95.19.58,1.5,4.87.61,8.96-.97,4.46-20.44,2.92-24.34,2.57-.11.01-14.69,1.05-24.68,1.05v.02h.01Z",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "228.38 206.07 117.82 206.07 157.56 75.28 201.64 75.28 228.38 206.07",
    fill: "#dddedf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-91f12725-4651-4192-855e-1b1e45ba96a1-3465",
    d: "m114.81,279.46c-1.32,8.01-6.66,13.76-11.93,12.83-5.27-.93-8.48-8.17-7.16-16.18.48-3.21,1.75-6.24,3.7-8.85l6.02-33.87,16.39,3.43-7.68,33.02c1.01,3.12,1.24,6.42.67,9.62h0s0,0,0,0Z",
    fill: "#f6a6a9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m164.52,75.3s-27.46-.72-30.35,6.5c-2.89,7.23-36.85,179.21-36.85,179.21h22.4s44.8-185.71,44.8-185.71Z",
    fill: "#dddedf"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.35,
    cy: 38.01,
    r: 24.21,
    fill: "#f6a6a9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m174.15,8.32s-31.08,46.23-25.85,75.07l-18.08-11.33s12.73-58.38,31.7-62.91l12.23-.84h0s0,.01,0,.01Z",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m205.4,206.07h-72.55l-39.7,162.93c-.73,6.88,3.63,13.3,10.32,15.09,21.78,5.83,74.04,14.1,153.15-8.92,7.61-2.21,11.93-10.24,9.54-17.8l-60.76-151.29h0s0-.01,0-.01Z",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m107.55,98.48l-.5-.5-.5.5c-24.33-24.31-63.76-24.28-88.07.05-24.31,24.34-24.8,64.26-.47,88.57h0l89.1,89.01,89.04-89.12h0c24.31-24.34,23.8-64.26-.52-88.57-24.33-24.31-63.76-24.28-88.07.05h0s0,0,0,0Z",
    fill: "#6ba6c7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m173.35,87.52l20.1-10.31c9.19-3.4,19.44-2.26,27.66,3.09,25,16.26,74.28,52.11,53.1,69.83-27.91,23.36-65.64-18.07-65.64-18.07l-35.22-44.54h0Z",
    fill: "#dddedf"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-8411e106-0120-401a-9ba4-6dca08ef376d-3466",
    d: "m172.91,105.14c-6.99-4.12-10.42-11.18-7.65-15.77,2.77-4.58,10.68-4.95,17.68-.83,2.82,1.61,5.19,3.89,6.91,6.65l29.4,17.86-9.12,14.04-28.02-19.1c-3.28-.19-6.44-1.17-9.21-2.86h.01Z",
    fill: "#f6a6a9"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.89 121.33 201.25 101.36 242.1 114.88 223.83 145.29 192.89 121.33",
    fill: "#dddedf"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaceJusticeSecondary);
export default __webpack_public_path__ + "static/media/peace-justice-secondary.c0c91a82342fd87c6602676ce8452fff.svg";
export { ForwardRef as ReactComponent };